import { LoanDefinitionRow } from '@dealstack/frontend/shared/components/LoanDefinitonTable/LoanDefinitionRow/LoanDefinitionRow';
import {
	LoanDefinitionForm,
	useLoanDefinitionTableController,
} from '@dealstack/frontend/shared/components/LoanDefinitonTable/useLoanDefinitionTableController';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { HeaderCell } from '@dealstack/frontend/shared/components/Table/DefaultTable/Cell';
import {
	BodyRow,
	HeaderRow,
	DefaultTable,
} from '@dealstack/frontend/shared/components/Table/DefaultTable/DefaultTable';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo, useEffect, useState } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import styled from 'styled-components';

interface Props {
	className?: string;
	loanDefinitionForm: UseFormReturn<LoanDefinitionForm, unknown>;
}

const LoanDefinitionTable = ({ loanDefinitionForm, className }: Props) => {
	const tCommonUi = useTranslationCommonUi();
	const { loanDefinitionFields, onAddLoanDefinitionRow, onRemoveLoanDefinitionRow } =
		useLoanDefinitionTableController(loanDefinitionForm);
	const [fieldsLength, setFieldsLength] = useState(true);
	useEffect(() => {
		setFieldsLength(loanDefinitionFields?.length === 0);
	}, [loanDefinitionFields]);

	return (
		<div className={className}>
			<FormProvider {...loanDefinitionForm}>
				<DefaultTable maxSize withEditableRows>
					<HeaderRow>
						<HeaderCell customSize="0.5fr">
							{tCommonUi('loan_definition.type')}
						</HeaderCell>
						<HeaderCell customSize="0.7fr">
							{tCommonUi('loan_definition.name')}
						</HeaderCell>
						<HeaderCell customSize="0.7fr">
							{tCommonUi('loan_definition.funder')}
						</HeaderCell>
						<HeaderCell size={2.1} />
					</HeaderRow>
					<BodyRow>
						{loanDefinitionFields?.map((security, index) => (
							<LoanDefinitionRow
								key={security.id}
								fieldIndex={index}
								onRemove={onRemoveLoanDefinitionRow(security.id)}
							/>
						))}
					</BodyRow>
				</DefaultTable>
				<AddAnotherButtonWrapper isEmpty={fieldsLength}>
					<AddAnotherButton
						onClick={onAddLoanDefinitionRow}
						iconSize="lg"
						icon="add-circle"
						iconPlacement="left"
						size="medium"
						variant="text"
					>
						{tCommonUi('common_buttons.add_another')}
					</AddAnotherButton>
				</AddAnotherButtonWrapper>
			</FormProvider>
		</div>
	);
};
const AddAnotherButtonWrapper = styled.div<{ isEmpty: boolean }>``;
const AddAnotherButton = styled(Button)`
	margin-top: 1em;
`;

const Memoized = memo(LoanDefinitionTable);
const Styled = styled(Memoized)`
	${DefaultTable} {
		overflow: visible;
	}
`;

export { Styled as LoanDefinitionTable };
